import React from "react";
import { LegalLayout, Section } from "@/pages/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Política de Privacidade">
      <p className="text-slate-400">Última atualização: 2026.</p>

      <Section heading="1. Dados que coletamos">
        <p>
          O Pronto.AI foi desenhado para coletar o mínimo necessário. Para gerar uma instrução,
          utilizamos apenas as respostas que você digita nos formulários. Não exigimos cadastro
          nem dados pessoais para usar a ferramenta de geração.
        </p>
      </Section>

      <Section heading="2. Como usamos as informações">
        <p>
          As respostas enviadas são utilizadas para gerar a instrução solicitada. Quando a geração
          por inteligência artificial está ativa, o texto enviado pode ser processado por um
          provedor de IA para produzir o resultado. Registramos apenas dados técnicos mínimos
          (como categoria e modelo escolhidos) para o funcionamento do serviço.
        </p>
      </Section>

      <Section heading="3. Não armazenamos dados desnecessários">
        <p>
          Não solicitamos informações pessoais sensíveis. Recomendamos que você não insira dados
          sensíveis (como senhas, números de documentos ou dados bancários) nos formulários.
        </p>
      </Section>

      <Section heading="4. Ferramentas de terceiros">
        <p>
          Pagamentos são processados por plataformas de checkout de terceiros, com suas próprias
          políticas de privacidade. Quando configurado, podemos utilizar ferramentas de medição de
          anúncios (como o TikTok Pixel) para entender a origem das visitas.
        </p>
      </Section>

      <Section heading="5. Seus direitos">
        <p>
          Você pode entrar em contato conosco para esclarecer dúvidas sobre o tratamento de dados,
          conforme a legislação aplicável (como a LGPD).
        </p>
      </Section>
    </LegalLayout>
  );
}
